var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTechDebtIcon = function SvgTechDebtIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#tech_debt_icon_svg__a)",
    d: "M37 22H13v13.5h24zM11.5 11.5h27A1.5 1.5 0 0 1 40 13v24a1.5 1.5 0 0 1-1.5 1.5h-27A1.5 1.5 0 0 1 10 37V13a1.5 1.5 0 0 1 1.5-1.5m3 4.5v3h3v-3zm6 0v3h3v-3zm-6 7.5H19V31h-4.5z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "tech_debt_icon_svg__a",
    x1: 10,
    x2: 40,
    y1: 25,
    y2: 25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7D52F4",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#7D52F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7D52F4",
    stopOpacity: 0.8
  })))));
};
export default SvgTechDebtIcon;